<template>
  <section ref="target" class="tablet:mb-1">
    <header :class="wrapperClass">
      <h3 class="article-title mb-5 text-center text-brand" >{{ t('instagram_feed.title') }}</h3>
    </header>
    <div class="relative">
      <div class="flex flex-wrap tablet:grid tablet:gap-1">
        <div
                v-for="i in gridItemCount"
                :key="i"
                class="grid-item"
                :class="gridItemClass"
        >
          <span class="bg-light aspect-square block w-full" />
        </div>
      </div>
      <div
              id="instafeed"
              class="flex flex-wrap tablet:grid tablet:gap-1 absolute inset-0 m-auto transition-all duration-1000 delay-300"
              :class="{
                'opacity-100': fade,
                'opacity-0': !fade
              }"
      />
    </div>

  </section>
</template>

<script setup lang="ts">
import { useIntersectionObserver } from '@vueuse/core'
import { ref } from 'vue'
import {useRuntimeConfig} from "#app";
const { t } = useI18n();
const config = useRuntimeConfig().public;

const { wrapperClass } = defineProps<{
    wrapperClass: string
}>();
const gridItemClass = 'flex-shrink-0 basis-1/2';
const gridItemCount = 8;
const fade = ref<boolean>(false);

const target = ref(null);
const scriptLoaded = ref(false);

const instagramConfig = config.instagram;

useIntersectionObserver(
        target,
        ([entry]) => {
            if (entry?.isIntersecting && !scriptLoaded.value) {
                getScriptAndToken();
            }
        },
);

function getScriptAndToken() {
    scriptLoaded.value = true;
    loadScript(instagramConfig.script_url, () => {
        const request = new XMLHttpRequest();
        request.open('GET', instagramConfig.token_api_url, true);
        request.onload = _ => {
            if (request.status >= 200 && request.status < 400) {
                // Success!
                const data = JSON.parse(request.responseText);
                initFeed(data.Token);
            }
        };
        request.send();
    });
}

function initFeed(token: string) {
    new Instafeed({
        accessToken: token,
        limit: 8,
        template: `
        <div class="grid-item ${gridItemClass}">
          <a href="{{link}}" target="_blank" class="block">
          <figure class="aspect-square w-full">
              <img src="{{image}}" alt="{{caption}}" class="w-full h-full object-cover">
              <figcaption class="sr-only">{{caption}}</figcaption>
          </figure>
          </a>
        </div>
        `,
        after() {
            fade.value = true;
        }
    }).run();
}
</script>

<style lang="scss">
.tablet\:grid {
  grid-template-areas: "highlight highlight . . ."
                         "highlight highlight . . .";
}

.grid-item:first-child {
  grid-area: highlight;
}

.grid-item:nth-child(7) {
  @media (min-width: 640px) {
    display: none !important;
  }
}
</style>
